import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import PropTypes from "prop-types"

class ActionDeleteModal extends Component {
    _actionDeleteSize = () => {
        const {index, onDeleteSizes} = this.props

        onDeleteSizes(index)
    }

    render() {
        const {isOpen, item, errorDelete, loadingDelete, onToggleModal} = this.props

        return <Modal isOpen={isOpen} toggle={onToggleModal}>
            <ModalHeader toggle={onToggleModal}>Xóa sản phẩm</ModalHeader>
            <ModalBody>
                <span>Bạn có chắc chắn muốn xóa size <strong>{item.sku}</strong>?</span>
                {errorDelete && <div className="text-danger mt-3">{errorDelete}</div>}
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between align-items-center">
                <Button color="secondary" disabled={loadingDelete}
                        onClick={onToggleModal}>Hủy</Button>
                <Button color="primary" disabled={loadingDelete}
                        onClick={this._actionDeleteSize}>{loadingDelete &&
                <i className='fa fa-spin fa-spinner mr-2'/>} Xóa</Button>
            </ModalFooter>
        </Modal>
    }
}

ActionDeleteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    item: PropTypes.object.isRequired,
    errorDelete: PropTypes.string,
    loadingDelete: PropTypes.bool.isRequired,
    onToggleModal: PropTypes.func.isRequired,
}

export default ActionDeleteModal